import { ProjectClient } from "@citrine/resources/project";
import type { Action } from "@citrine/resources/team-member";
import {
  TeamMemberClient,
  hasWritePermission,
} from "@citrine/resources/team-member";
import { UserClient } from "@citrine/resources/user";

/**
 *
 * @param teamId
 */
function useGetActiveUsersPermissionsInTeam(
  teamId?: string
): Action[] | undefined {
  const me = UserClient.getInstance().useGetMe();
  const teamActionsQuery = TeamMemberClient.getInstance(teamId).useGet(
    me.data!.id
  );
  return teamActionsQuery.data?.actions;
}

/**
 *
 * @param projectId - string id of the project for that dataset
 */
function useGetActiveUsersPermissionsInProject(
  projectId?: string
): Action[] | undefined {
  const projectQuery = ProjectClient.getInstance().useGet(projectId, {
    // projects cannot change teams
    staleTime: Infinity,
  });
  return useGetActiveUsersPermissionsInTeam(projectQuery.data?.team.id);
}

export function useHasExportPermission() {
  return Boolean(UserClient.getInstance().useGetMe().data!.can_download);
}

/**
 * If the team actions query is still pending returns undefined, else returns
 * a boolean
 */
export function useHasWritePermission(projectId: string) {
  const actions = useGetActiveUsersPermissionsInProject(projectId);
  return actions ? hasWritePermission(actions) : undefined;
}

/**
 * If the team actions query is still pending returns undefined, else returns
 * a boolean
 */
export function useHasWritePermissionForTeam(teamId: string) {
  const actions = useGetActiveUsersPermissionsInTeam(teamId);
  return actions ? hasWritePermission(actions) : undefined;
}
